<template>
    <div>
        <el-row class="searchSection">
            <el-col :span="8" :offset="8">
                <el-tabs v-model="searcheModel.tab" @tab-click="handleClick">
                    <el-tab-pane label="销售提成业绩明细" name="sale-bonus"></el-tab-pane>
                    <el-tab-pane label="绩效激励业绩明细" name="merit-bonus"></el-tab-pane>
                </el-tabs>
            </el-col>
        </el-row>
        <el-row class="searchSection">
            <el-form ref="form" :inline="true" :model="searcheModel" class="external-form">
                <el-form-item label="结算月份">
                    <el-date-picker
                    size="small"
                    v-model="searcheModel.settle_months"
                    type="monthrange"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="submitSearch">开始汇算</el-button>
                    <el-button @click="resetForm()" size="small">重置</el-button>
                    <ExportFile 
                    v-if="Acs('/export/confirm-detail')" 
                    url="/api/export/confirm-detail" 
                    :params="searcheModel" 
                    filename="业绩汇总明细" 
                    buttonName="导出Excel">
                    </ExportFile>
                </el-form-item>
            </el-form>
        </el-row>
        <el-row class="addBtn">
            <el-button v-if="Acs('/user-orders/confirm-pfm')" type="success" :disabled="multipleSelection.length == 0" @click="batchShowDialog()" size="small">批量确认业绩</el-button>
        </el-row>
        <div v-loading="loading">
            <el-table 
            v-if="!loading"
            :data="list" 
            border 
            height="650"
            :header-cell-style="{background: '#f3faff'}"
            @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" prop="checkbox" :selectable="selectable" width="55"></el-table-column>
                <el-table-column label="订单ID" width="100">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleView(scope.row)">
                            {{ scope.row.order_id }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="业务员"></el-table-column>
                <el-table-column prop="branch_name" label="所属部门"></el-table-column>
                <el-table-column prop="district_names" label="所在地区"></el-table-column>
                <el-table-column label="发票抬头">
                    <template slot-scope="scope">
                        {{ scope.row.invoice_title }}
                    </template>
                </el-table-column>
                <el-table-column prop="total_amount" label="销售额">
                    <template slot-scope="scope">
                        <el-dropdown placement="top">
                            <span class="el-dropdown-link">
                                {{ scope.row.total_amount }}
                            </span>
                            <el-dropdown-menu slot="dropdown" :style="{ width: scope.row.products.length > 13 ? '100%' : scope.row.products.length * 7 + '%' }">
                                <el-table :data="[{products: scope.row.products}]" border>
                                    <el-table-column v-for="(item, key) in scope.row.products" :key="key" :label="item.product_name">
                                        <template>
                                            {{ item.product_amount }}
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
                <el-table-column width="110">
                    <template slot="header">
                        <!-- 自定义表头 -->
                        <span>合作期间</span>
                        <el-tooltip class="item" effect="dark" content="合同结束时间-合同开始时间结束" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row.contract_times }}
                    </template>
                </el-table-column>
                <el-table-column prop="rebate_amount" width="110">
                    <template slot="header">
                        <!-- 自定义表头 -->
                        <span>销二费用</span>
                        <el-tooltip class="item" effect="dark" content="销售额-新增业绩-续费业绩" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row.rebate_amount }}
                    </template>
                </el-table-column>
                <el-table-column prop="performance" label="新增业绩"></el-table-column>
                <el-table-column prop="renew" label="续费业绩"></el-table-column>
                <el-table-column prop="proxy_performance" width="130">
                    <template slot="header">
                        <!-- 自定义表头 -->
                        <span>代理新增业绩</span>
                        <el-tooltip class="item" effect="dark" content="签单模式为代理自签单的新增业绩" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row.proxy_performance }}
                    </template>
                </el-table-column>
                <el-table-column prop="proxy_renew" width="130">
                    <template slot="header">
                        <!-- 自定义表头 -->
                        <span>代理续费业绩</span>
                        <el-tooltip class="item" effect="dark" content="签单模式为代理自签单的续费业绩" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row.proxy_renew }}
                    </template>
                </el-table-column>
                <el-table-column prop="stop_renew" width="130">
                    <template slot="header">
                        <!-- 自定义表头 -->
                        <span>断续新增业绩</span>
                        <el-tooltip class="item" effect="dark" content="在订单合同时间到期后6~24个月内，更换了客户绑定业务员/协作人，开通的正式订单中的新增业绩" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row.stop_renew }}
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="录单时间" width="100"></el-table-column>
                <el-table-column prop="contract_at" label="合同回传时间" width="120"></el-table-column>
                <el-table-column prop="actual_at" label="实际回款时间" width="120"></el-table-column>
                <el-table-column prop="confirm_at" label="汇算月份" width="120"></el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-if="Acs('/user-orders/confirm-pfm') && !scope.row.confirm_at" :type="scope.row.confirm_at ? 'warning' : 'primary'" size="small" @click="showDialog(scope.row, false)">确认</el-button>
                        <el-button v-else-if="Acs('/user-orders/update-pfm') && scope.row.confirm_at" :type="scope.row.confirm_at ? 'warning' : 'primary'" size="small" @click="showDialog(scope.row, true)">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
        </div>

        <el-dialog title="确认业绩" :visible.sync="dialogFormVisible" width="20%" center>
            <el-form :model="form" ref="form" :rules="rules">
                <el-form-item label="选择汇算月" prop="confirm_at">
                    <el-date-picker
                    size="small"
                    v-model="form.confirm_at"
                    type="month"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    >
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <br>
            <p style="color:red;text-align:center;font-size:15px;">确认后，业绩将计算在选择月份</p>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button v-if="is_edit" type="primary" @click="updatePfm()">修 改</el-button>
                <el-button v-else type="primary" @click="confirmPfm()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
  </template>
  <style scoped>
  
  </style>
  <script>
  import PerformanceCalcCount from "~/services/PerformanceCalcCount";
  import UserOrders from "~/services/UserOrders";
  import Config from "~/config/params";
  import ExportFile from "~/widgets/ExportFile.vue";
  import MyPagination from "~/widgets/MyPagination.vue";
  export default {
    name: "ConfirmDetail",
  
    components: {
        Config,
        ExportFile,
        MyPagination
    },
  
    props: {
        
    },
  
    data() {
        return {
            loading: false,
            searcheModel: {},
            // 分页信息
            linkPage: null,
            list: [],
            activeName: 'sale-bonus',
            count_config_key: 0,
            fields: [
                {field: 'order_id', label: '订单ID'},
                {field: 'name', label: '业务员'},
                {field: 'branch_name', label: '所属部门'},
                {field: 'district_names', label: '所在地区'},
                {field: 'invoice_title', label: '发票抬头'},
                {field: 'total_amount', label: '销售额'},
                {field: 'contract_times', label: '合作期间'},
                {field: 'rebate_amount', label: '销二费用'},
                {field: 'performance', label: '新增业绩'},
                {field: 'renew', label: '续费业绩'},
                {field: 'proxy_performance', label: '代理新增业绩'},
                {field: 'proxy_renew', label: '代理续费业绩'},
                {field: 'stop_renew', label: '断续新增业绩'},
                {field: 'created_at', label: '录单时间'},
                {field: 'contract_at', label: '合同回传时间'},
                {field: 'actual_at', label: '实际回款时间'},
                {field: 'confirm_at', label: '汇算月月份'},
            ],

            multipleSelection: [],
            form: {
                ids: [],
                confirm_at: '',
            },
            dialogFormVisible: false,
            rules: {
                confirm_at: [{required: true, message: "请选择汇算月月份"}]
            },
            is_edit: false,
        };
    },
  
    mounted() {
    },
  
    created() {
        this.resetForm(this.$route.query);
    },
  
    methods: {
        //重置按钮
        resetForm(params = null) {
            this.list = [];
            if(params && Object.keys(params).length > 0){
                this.searcheModel = Object.assign({}, this.searcheModel, params);
            }else{
                this.searcheModel = {
                    settle_months: Config.getDataTimes('this_month'),
                    path: this.$route.path,
                    tab: this.activeName,
                };
            }
            this.submitSearch();
        },
    
        // 筛选查询
        submitSearch() {
            this.multipleSelection = [];
            let params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getList(params);
        },
    
        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            PerformanceCalcCount.getConfirmDetail(params).then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                if (res._meta) {
                    this.linkPage = res._meta;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },
    
        handleClick(){
            this.activeName = this.searcheModel.tab;
            this.count_config_key ++;
            this.submitSearch();
        },

        // 查看
        handleView(row) {
            let routeData = this.$router.resolve({
                path: "/order/view",
                query: {id: row.order_id},
            });
            window.open(routeData.href, '_blank');
        },

        handleSizeChange(newSize) {
            // 处理每页条目数变化事件
            this.searcheModel['perPage'] = newSize;
            this.submitSearch();
        },

        handleCurrentChange(newPage) {
            // 处理当前页码变化事件
            this.searcheModel['page'] = newPage;
            this.submitSearch();
        },

        selectable(row, index){
            return !row.confirm_at;
        },

        handleSelectionChange(val) {
            this.multipleSelection = val.filter(item => !item.confirm_at);
            // console.log('handleSelectionChange: ', this.multipleSelection);
        },

        batchShowDialog(){
            this.form.confirm_at = '';
            this.form.ids = this.multipleSelection.map(item => item.id);
            this.dialogFormVisible = true;
        },

        showDialog(row, is_edit){
            this.form.confirm_at = row.confirm_at;
            this.form.ids = [row.id];
            this.is_edit = is_edit;
            if(is_edit){
                this.rules = {};
            }else{
                this.rules = {
                    confirm_at: [{required: true, message: "请选择汇算月月份"}]
                };
            }
            this.dialogFormVisible = true;
        },

        //确认业绩
        confirmPfm(){
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.$confirm('确认业绩后订单将会参与选定月份的业绩汇总，请务必仔细核对后确认！', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.form['tab'] = this.searcheModel.tab
                        UserOrders.confirmPfm(this.form).then(res => {
                            if (res.code == 0) {
                                this.$message({
                                    message: "操作成功",
                                    type: "success"
                                });
                                this.dialogFormVisible = false;
                                this.submitSearch();
                            }
                        });
                    }).catch(() => {
                        
                    });
                    
                }
            });
            
        },

        //修改业绩业绩
        updatePfm(){
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.form['tab'] = this.searcheModel.tab
                    UserOrders.updatePfm(this.form).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message: "操作成功",
                                type: "success"
                            });
                            this.dialogFormVisible = false;
                            this.submitSearch();
                        }
                    });
                }
            });
        }
    },
  };
  </script>


// WEBPACK FOOTER //
// src/views/count/performance/confirmDetail.vue